import { render, staticRenderFns } from "./ApplicationFieldReadOnly.vue?vue&type=template&id=81ea2dea&scoped=true&"
import script from "./ApplicationFieldReadOnly.vue?vue&type=script&lang=js&"
export * from "./ApplicationFieldReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFieldReadOnly.vue?vue&type=style&index=0&id=81ea2dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ea2dea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
